/**
 * BrandAuditListPresenter
 * --
 */
import React, { useState } from 'react';
import {
  Content,
  Row,
  Col,
  ExpandableContainer,
  Table,
  ModalLayout,
  Descriptions,
} from 'components';
import { Button, DatePicker, Input, Radio, Select } from 'antd';
import moment from 'moment';

const BrandAuditListPresenter = ({ permission }) => {
  console.log('permission: ', permission);
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [isDrawerOpened, setIsDrawerOpened] = useState(false);
  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const formItem = [
    {
      label: '입점구분',
      form: [
        {
          input: (
            <Radio.Group value={'전체'}>
              <Radio value={'전체'}>전체</Radio>
              <Radio value={'입점업체'}>입점업체</Radio>
              <Radio value={'입점 신청 업체'}>입점 신청 업체</Radio>
              <Radio value={'입점 심사중 업체'}>입점 심사중 업체</Radio>
              <Radio value={'입점 탈퇴 업체'}>입점 탈퇴 업체</Radio>
            </Radio.Group>
          ),
        },
      ],
    },
    {
      label: '업체명',
      form: [
        {
          input: (
            <Select
              size="large"
              value={'전체'}
              options={[{ label: '전체', value: '전체' }]}
              style={{ ...styles.form.input.large }}
            />
          ),
        },
        {
          input: (
            <Input
              size="large"
              style={{ ...styles.form.input.large }}
              placeholder="업체 이름, 코드를 입력해주세요"
            />
          ),
        },
      ],
    },
    {
      label: '사업자 번호',
      form: [
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="사업자 번호를 입력하세요"
                style={{ ...styles.form.input.large }}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '업체 등록 기간',
      form: [
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              오늘
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1주일
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              3개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              전체
            </Button>
          ),
        },
        {
          input: (
            <>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
            </>
          ),
        },
      ],
    },
  ];

  // NOTE: 테이블 가짜 데이터
  let newData = [
    {
      등록일: moment(),
      업체명: 'abc커피',
      아이디: 'abccoffee',
      사업자번호: '1234567898',
      created_at: moment(),
    },
  ];

  let newData2 = [];

  // NOTE: 가짜 모달 데이터
  const descriptionsItems = [
    {
      key: `1`,
      label: '업체코드',
      children: '000000',
      span: 2,
    },
    {
      key: `2`,
      label: '등록일',
      children: moment().format('YYYY년 MM월 DD일 HH:mm:ss'),
      span: 2,
    },
    {
      key: `3`,
      label: '업체명',
      children: (
        <button
          style={{
            border: 'none',
            background: 'none',
            textDecoration: 'underline',
            color: '#1C6BFF',
            cursor: 'pointer',
          }}
        >
          컴포즈커피
        </button>
      ),
      span: 2,
    },
    {
      key: `4`,
      label: '브랜드여부',
      children: (
        <>
          <p>N</p>
        </>
      ),
    },
    {
      key: `5`,
      label: '등록상품',
      children: (
        <>
          <p>112개</p>
        </>
      ),
    },
    {
      key: `6`,
      label: '대표자 명',
      children: (
        <>
          <p>김길동</p>
        </>
      ),
    },
    {
      key: `7`,
      label: '대표 연락처',
      children: (
        <>
          <p>010-1234-5678</p>
        </>
      ),
    },
    {
      key: `8`,
      label: '담당자 명',
      children: (
        <>
          <p>홍길동</p>
        </>
      ),
    },
    {
      key: `9`,
      label: '담당자 연락처',
      children: (
        <>
          <p>010-4321-5678</p>
        </>
      ),
    },
    {
      key: `9`,
      label: '사업자 번호',
      children: (
        <>
          <p>1234-5678-90</p>
        </>
      ),
    },
    {
      key: `10`,
      label: '영업 시간',
      children: (
        <>
          <p>100H+</p>
        </>
      ),
    },
  ];

  // NOTE: 가짜 모달 데이터
  const descriptionsItems2 = [
    {
      key: `1`,
      label: '사업자 등록증',
      children: (
        <p
          style={{
            textDecoration: 'underline',
            color: '#1C6BFF',
            cursor: 'pointer',
          }}
        >
          컴포즈커피_사업자등록증.pdf
        </p>
      ),
      span: 2,
    },
    {
      key: `2`,
      label: '기타 서류',
      children: (
        <p
          style={{
            textDecoration: 'underline',
            color: '#1C6BFF',
            cursor: 'pointer',
          }}
        >
          재무재표.pdf
        </p>
      ),
      span: 2,
    },
  ];

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
        <Row>
          <Col x={24}>
            {/* <Content maxWidth={'100%'} borderRadius={4} padding={20}>
            <Empty
              style={{
                height: 500,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
              }}
              description={
                <>
                  <Title align={'center'}>개발중입니다.</Title>
                </>
              }
            ></Empty>
          </Content> */}

            {/* 검색필터 */}
            <Content
              maxWidth={'100%'}
              padding={0}
              backgroundColor={'none'}
              style={{ marginBottom: 40 }}
            >
              <ExpandableContainer borderRadius={4} padding={20}>
                {formItem.map((_item, _index) => (
                  <div
                    key={`form_${_index}`}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '10px 0px',
                    }}
                  >
                    <div style={{ width: 120, fontSize: 13, fontWeight: 400 }}>
                      <label>{_item.label}</label>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      {_item.form.map((_subitem, _subkey) => (
                        <React.Fragment key={`input_${_subkey}`}>
                          {_subitem.input}
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                ))}
              </ExpandableContainer>

              {/* 검색/초기화 버튼 */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                  marginTop: 48,
                }}
              >
                <Button
                  size="large"
                  type="primary"
                  style={{
                    ...styles.button,
                    background: 'var(--primary-color)',
                  }}
                >
                  검색
                </Button>
                <Button size="large" style={{ ...styles.button }}>
                  초기화
                </Button>
              </div>
              {/* 검색/초기화 버튼 끝 */}
            </Content>
            {/* 검색필터 끝 */}

            {/* 검색결과 */}
            <Content maxWidth={'100%'} borderRadius={4} padding={20}>
              <h4 style={{ fontSize: 14, fontWeight: 500, marginBottom: 12 }}>
                검색 결과 총 <span>0</span>건
              </h4>
              <Table
                data={newData}
                columns={[
                  {
                    title: '등록일',
                    key: '등록일',
                    render: (_item) =>
                      moment(_item).format('YYYY-MM-DD HH:mm:ss'),
                  },
                  {
                    title: '업체명',
                    key: '업체명',
                  },
                  {
                    title: '아이디',
                    key: '아이디',
                  },
                  {
                    title: '사업자 번호',
                    key: '사업자번호',
                  },
                  {
                    title: '회원가입 일',
                    key: 'created_at',
                    render: (item) => moment(item).format('YYYY-MM-DD'),
                  },
                ]}
                onRow={() => setIsDrawerOpened(!isDrawerOpened)}
              />
            </Content>
            {/* 검색결과 끝 */}
          </Col>
        </Row>
      </Content>
      {/* Drawer */}
      <ModalLayout
        type={'drawer'}
        open={isDrawerOpened}
        onCancel={setIsDrawerOpened}
        centered
        title={`입점업체 상세정보`}
        width={'30%'}
        footer={
          <Content
            maxWidth={'100%'}
            padding={10}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div>
              <Button onClick={() => setIsDrawerOpened(false)}>닫기</Button>
            </div>
          </Content>
        }
      >
        <Content maxWidth={'100%'} padding={0}>
          <Row>
            <Col x={24}>
              <Content maxWidth={'100%'} padding={0}>
                <h4
                  style={{
                    fontSize: 16,
                    fontWeight: 600,
                    color: '#404040',
                    marginBottom: 20,
                  }}
                >
                  입점업체 정보
                </h4>
                <Descriptions items={descriptionsItems} />
              </Content>

              <Content maxWidth={'100%'} padding={0} style={{ marginTop: 40 }}>
                <h4
                  style={{
                    fontSize: 16,
                    fontWeight: 600,
                    color: '#404040',
                    marginBottom: 20,
                  }}
                >
                  등록 상품 총 0건
                </h4>
                <Table
                  data={newData2}
                  columns={[
                    {
                      title: '카테고리',
                      key: '카테고리',
                    },
                    {
                      title: '상품코드',
                      key: '상품코드',
                    },
                    {
                      title: '이미지',
                      key: '이미지',
                    },
                    {
                      title: '상품명',
                      key: '상품명',
                    },
                    {
                      title: '판매가',
                      key: '판매가',
                    },
                    {
                      title: '할인가',
                      key: '할인가',
                    },
                    {
                      title: '수량',
                      key: '수량',
                    },
                    {
                      title: '리뷰',
                      key: '리뷰',
                    },
                    {
                      title: '적용 프로모션',
                      key: '적용프로모션',
                    },
                    {
                      title: '판매처',
                      key: '판매처',
                    },
                  ]}
                  minHeight={'auto'}
                />
              </Content>
              <Content maxWidth={'100%'} padding={0} style={{ marginTop: 40 }}>
                <Descriptions items={descriptionsItems2} />
              </Content>
            </Col>
          </Row>
        </Content>
      </ModalLayout>
    </>
  );
};

export default BrandAuditListPresenter;
